import {Injectable} from '@angular/core';
import sdk from "@sp400/sdk"
import {SpaceConfig} from "@sp400/core/src/types/space";
import {LoadingService} from './loading.service';
import {ErrorProviderService} from './error-provider.service';
import {UtilService} from './util.service';
import {environment} from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class SdkService {

  SDK_Config: SpaceConfig = environment.SDK_CONFIG as SpaceConfig;

  constructor(private loadingService: LoadingService,
              private errorProviderService: ErrorProviderService,
              private utilService: UtilService) {
  }

  async initializeSDK(): Promise<boolean> {
    localStorage.setItem('SpaceSDKConfiguration', JSON.stringify({
      env: "intg",
      source: "omni",
      gigya_api_key: this.SDK_Config && this.SDK_Config.credentials && this.SDK_Config.credentials.apiKey ? this.SDK_Config.credentials.apiKey : "", // "3_xSF8rYIXw_7oO0MGwMaBaCjmfMkT5z0RmPh-7Tk_42c0Tpm7Wyynulx8OKpZksGD",
      brand: this.SDK_Config.brand,
      country: this.SDK_Config.countryCode,
      language: this.SDK_Config.language
    }));

    localStorage.setItem('SpaceMonitoring', this.SDK_Config.monitoring + "");

    return sdk.initialize(this.SDK_Config);
  }

  isInitialized(): Promise<boolean> {
    return sdk.isReady();
  }

  /**
   * Used to get the response from sdk
   * @param action
   * @param params
   * @param showError //Send false if you don't want to show common error
   */
  async get(action: string, params: any = {}, showError = true): Promise<any> {
    const response = await sdk.get(action, params).catch(error => {
      this.errorHandler(error, showError);
    });
    if (response && response.errors) {
      this.errorHandler(response.errors, showError);
    }
    return response;
  }

  /**
   * Used to get the response from sdk
   * @param action
   * @param params
   * @param showError //Send false if you don't want to show common error
   */
  async set(action: string, params: any = {}, showError = true): Promise<any> {
    const response = await sdk.set(action, params).catch(error => {
      this.errorHandler(error, showError);
    });
    if (response && response.errors) {
      this.errorHandler(response.errors, showError);
    }
    return response;
  }

  private errorHandler(errors: any, showError: boolean) {
    this.loadingService.hideLoading();
    if (showError) {
      const errorInfo = this.errorProviderService.getErrorInfo(errors);
      this.utilService.showToastMessage({
        type: "Error",
        description: errorInfo.displayMessage,
        errorCode: errorInfo.errorCode
      });
    }
  }
}
